import { useCallback, useEffect, useRef, useState } from 'react';


export default function useTestAutoSave(updateTestResults, onExpireTest, onUpdateTotalAnswered) {
    const autoSaveIntervalRef = useRef(null);
    const previousFormDataHashRef = useRef({});
    const formDataHashRef = useRef({});
    const [autoSaveInitialized, setAutoSaveInitialized] = useState(false);

    const hashCode = useCallback((str) => {
        let hash = 0;
        if (str.length === 0) return hash;
        for (let i = 0; i < str.length; i++) {
            const chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0;
        }
        return hash;
    }, []);

    const handleUpdateTestResults = (data) => {
        previousFormDataHashRef.current[page] = formDataHashRef.current[page];
        if(data.testResult != undefined) {
            if(data.testResult.expired && onExpireTest instanceof Function) {
                onExpireTest();
            }
            if(onUpdateTotalAnswered instanceof Function) {
                onUpdateTotalAnswered(data.testResult.totalAnswered);
            }
        }
    }

    const autoSaveQuestions = useCallback(
        (testElement, enableUpdate) => {
            const questionPages = testElement.querySelectorAll('.js-testQuestionPage');
            questionPages.forEach((pageForm) => {
                const page = pageForm.dataset.page || 1;

                const formData = new FormData(pageForm);
                const formDataObj = Object.fromEntries(formData.entries());
                const formDataStr = JSON.stringify(formDataObj);
                formDataHashRef.current[page] = hashCode(formDataStr);

                if (
                    previousFormDataHashRef.current[page] === undefined ||
                    formDataHashRef.current[page] !== previousFormDataHashRef.current[page]
                ) {
                    if (enableUpdate) {
                        updateTestResults({submitAnswers: true, onComplete: handleUpdateTestResults});
                    } else {
                        previousFormDataHashRef.current[page] = formDataHashRef.current[page];
                    }
                }

                previousFormDataHashRef.current[page] = formDataHashRef.current[page];
            });
        },
        [updateTestResults, hashCode]
    );

    const initAutoSave = useCallback(
        (testElement) => {
            autoSaveQuestions(testElement, false);
            setAutoSaveInitialized(true);
            if (autoSaveIntervalRef.current) {
                clearInterval(autoSaveIntervalRef.current);
            }
            autoSaveIntervalRef.current = setInterval(() => {
                autoSaveQuestions(testElement, true);
            }, 2500);
        },
        [autoSaveQuestions]
    );

    const startTestAutoSave = useCallback(
        (testElement, callback) => {
            if(testElement == undefined) {
                log.error('No test element found.');
                return;
            }
            inlineQuestions.insertBatchAnswers($('.js-testContent', testElement), {}, false);
            inlineQuestions.buildQuestionTypes($('.js-testContent', testElement));

            setAutoSaveInitialized(true);
            initAutoSave(testElement);

            if (typeof callback === 'function') {
                callback();
            }
        },
        [initAutoSave]
    );

    const updateTabProgressBar = useCallback(
        (testElement, onUpdateTotalAnswered) => {
            if(testElement == undefined) {
                return;
            }

            const questions = testElement.querySelectorAll('.js-react-question');
            questions.forEach((question) => {
                const questionId = question.dataset.questionId;
                const tabQuestion = testElement.querySelector(
                    `.ch-page-question-result[data-question-id="${questionId}"]`
                );
                if (!tabQuestion) return;

                if (anyInputHasValue($(question))) {
                    tabQuestion.classList.add('ch-complete-bg');
                } else {
                    tabQuestion.classList.remove('ch-complete-bg');
                }
            });

            const totalAnswered = testElement.querySelectorAll(
                '.ch-page-question-result.ch-complete-bg'
            ).length;
            if(onUpdateTotalAnswered instanceof Function) {
                onUpdateTotalAnswered(totalAnswered);
            }
        },
        [anyInputHasValue]
    );

    useEffect(() => {
        return () => {
            if (autoSaveIntervalRef.current) {
                clearInterval(autoSaveIntervalRef.current);
            }
        };
    }, []);

    return {
        startTestAutoSave,
        autoSaveQuestions,
        initAutoSave,
        updateTabProgressBar
    };
}
